import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';
import { EndPoint } from '../config/endpoint';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileMediaService {
  constructor(private httpService: HttpService) {}

  async updateProfile(formData, mediaId) {
    const token = await firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.UserProfileMedia}/${mediaId}`, formData),
    );
    return this.httpService.decodeTokenPagination(token);
  }

  async uploadProfile(formData) {
    const token = await firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.UserProfileMedia}`, formData),
    );
    return this.httpService.decodeTokenPagination(token);
  }

  async deleteProfile(id: number) {
    try {
      return await firstValueFrom(
        this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.UserProfileMedia}/${id}`),
      );
    } catch (error) {
      throw error;
    }
  }
}
